/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit'; 
import { getAllOrg, getAllOrgHistory } from './organizationAction';
 
const initialState = {
    data: {},
    organizations: {},
    organizationHistory: {}
}
const organizationSlice = createSlice({
    name: 'organization',
    initialState,
    extraReducers: {

        [getAllOrg.fulfilled]: (state, { payload }) => {
            state.organizations =  payload;
        },
        [getAllOrgHistory.fulfilled]: (state, { payload }) => {
            state.organizationHistory =  payload;
        },
        [getAllOrgHistory.rejected]: (state, { payload }) => {
            state.organizationHistory =  {};
        },
    }
});

export default organizationSlice.reducer